/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Cta_BtnInputs */

const es_l6_cta_btn = /** @type {(inputs: L6_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da de alta tu charter`)
};

const gl_l6_cta_btn = /** @type {(inputs: L6_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da de alta o teu charter`)
};

const en_l6_cta_btn = /** @type {(inputs: L6_Cta_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List your charter`)
};

/**
* | output |
* | --- |
* | "List your charter" |
*
* @param {L6_Cta_BtnInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_cta_btn = /** @type {((inputs?: L6_Cta_BtnInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Cta_BtnInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_cta_btn(inputs)
	if (locale === "en") return en_l6_cta_btn(inputs)
	return es_l6_cta_btn(inputs)
});